import { useWatch } from 'react-hook-form';
import { get } from 'lodash';

import { passValidationData } from 'constants/passwordValidation';

export const usePasswordValidation = ({ control, dirtyFields, passFieldName, confirmPassFieldName }) => {
  const [passwordValue, confirmPassValue] = useWatch({
    control,
    name: [passFieldName, confirmPassFieldName],
  });

  const passwordValidation = passValidationData.reduce(
    (acc, { key, regex }) => ({
      ...acc,
      [key]: regex.test(passwordValue),
    }),
    {},
  );

  const confirmPassError = get(dirtyFields, passFieldName, false) &&
    get(dirtyFields, confirmPassFieldName, false) &&
    passwordValue !== confirmPassValue && { message: "Oops, that password doesn't match. Please try again" };

  const isValidPasswordValues = !!passwordValue && !!confirmPassValue && !confirmPassError;

  return { passwordValidation, confirmPassError, isValidPasswordValues };
};
